import { Select } from "antd";
import { ESTADOS } from "std/const/estados";
import { filterOption } from "std/util";

const options = ESTADOS.map((est) => ({
	value: est.sigla,
	label: `${est.sigla} - ${est.nome}`,
}));

export function SelectUf({ id, disabled, value, onChange }: { id?: string; disabled?: boolean; value?: string; onChange?: (value: string) => void }) {
	return (
		<Select
			id={id}
			disabled={disabled}
			placeholder="Selecione o Estado"
			style={{ width: "100%" }}
			allowClear={true}
			showSearch={true}
			filterOption={filterOption}
			options={options}
			value={value}
			onChange={onChange}
		/>
	);
}
